import type { KartWeightClass } from "./simulation/types";

export const KART_WEIGHT_CLASSES = ["light", "medium", "heavy"] as const;

export interface KartWeightProfile {
  maxSpeed: number;
  boostSpeed: number;
  acceleration: number;
  braking: number;
  steering: number;
  driftCharge: number;
  miniTurboDuration: number;
  grip: number;
  offRoadDrag: number;
  launch: number;
  mass: number;
  visualScale: number;
}

const PROFILES: Record<KartWeightClass, KartWeightProfile> = {
  light: { maxSpeed: 0.965, boostSpeed: 0.985, acceleration: 1.12, braking: 1.08, steering: 1.1, driftCharge: 1.1, miniTurboDuration: 0.9, grip: 0.94, offRoadDrag: 0.86, launch: 1.07, mass: 0.78, visualScale: 0.94 },
  medium: { maxSpeed: 1, boostSpeed: 1, acceleration: 1, braking: 1, steering: 1, driftCharge: 1, miniTurboDuration: 1, grip: 1, offRoadDrag: 1, launch: 1, mass: 1, visualScale: 1 },
  heavy: { maxSpeed: 1.075, boostSpeed: 1.05, acceleration: 0.92, braking: 0.94, steering: 0.9, driftCharge: 0.9, miniTurboDuration: 1.15, grip: 1.1, offRoadDrag: 1.1, launch: 0.94, mass: 1.28, visualScale: 1.06 },
};

export function normalizeKartWeightClass(value: unknown): KartWeightClass {
  return value === "light" || value === "heavy" ? value : "medium";
}

export function getKartWeightProfile(value: unknown): KartWeightProfile {
  return PROFILES[normalizeKartWeightClass(value)];
}

export function defaultKartWeightForVariant(variant: number): KartWeightClass {
  const normalized = ((Math.floor(variant) % 7) + 7) % 7;
  if (normalized === 1 || normalized === 4) return "light";
  if (normalized === 3 || normalized === 6) return "heavy";
  return "medium";
}
